import React, {CSSProperties} from 'react'
import Spinner from './Spinner'
import {AutoSizer} from 'react-virtualized'
import {Col, Row} from './Display'

type ButtonType = 'cta' | 'smallCta'

type ButtonProps = {
  content: React.ReactNode
  onClick?: (event: any) => void
  disabled?: boolean
  loading?: boolean
  className?: string
  type?: ButtonType
  style?: CSSProperties
}

const buttonClasses: {[k in ButtonType]: string} = {
  cta: 'bg-itx-primary-3 border-itx-primary-3 text-white',
  smallCta: 'itx-sm-button items-center',
}

export default function Button(props: ButtonProps) {
  const classes = ['itx-button rounded border px-4 text-black font-regular']
  if (props.className) {
    classes.push(props.className)
  }

  if (props.type) {
    classes.push(buttonClasses[props.type])
  }

  if (props.disabled) {
    classes.push('cursor-not-allowed opacity-50')
  } else {
    classes.push('hover:shadow-md transition duration-200')
  }

  return (
    <button className={classes.join(' ')} disabled={props.disabled} onClick={props.onClick}>
      {props.loading && (
        <AutoSizer>
          {(size) => {
            return (
              <Col className="absolute justify-center items-center" style={{width: size.width, height: size.height}}>
                <Spinner />
              </Col>
            )
          }}
        </AutoSizer>
      )}
      <Row style={props.style} className={`itx-button justify-center items-center text-sm font-bold ${props.loading ? 'opacity-0' : ''}`}>
        {props.content}
      </Row>
    </button>
  )
}
